import TNode from "./TNode";
import {normalizeString} from "../../shared/helpers";
import m, {Vnode} from "mithril";

export default class TreeNode {

    private isOpen;
    public isVisible = true;
    private subTree: null|TreeNode[];
    private normalizedLabel;

    constructor(
        public readonly parent: null|TreeNode,
        public readonly node: TNode,
        private readonly isSelected: (nodePath: TNode[])=>boolean,
        private readonly setNode: (nodePath: TNode[])=>void,
    ) {
        this.normalizedLabel = normalizeString(node.label);
        this.isOpen = isSelected(this.getNodePath())
        this.subTree = this.node.subTree?.map(node => new TreeNode(this, node, isSelected, setNode)) ?? null;
    }

    public close(): void {
        this.isOpen = false;
        this.subTree?.forEach(node => node.close());
    }

    public open(): void {
        this.isOpen = true;
        this.parent?.open();
    }

    public toggle(): void {
        this.isOpen ? this.close() : this.open();
    }

    private makeVisible(): void {
        this.isVisible = true;
        this.parent?.makeVisible();
    }

    public search(phrase: string): void {
        if (this.isRoot) {
            this.close();
        }
        if (!phrase) {
            this.isVisible = true;
        } else {
            if (this.normalizedLabel.search(phrase) === -1) {
                this.isVisible = false;
            } else {
                this.parent?.open()
                this.makeVisible();
            }
        }
        this.subTree?.forEach(node => node.search(phrase));
    }

    public get isRoot(): boolean {
        return !this.parent;
    }

    public get isLeaf(): boolean {
        return !this.subTree?.length;
    }

    public getNodePath(): TNode[] {
        return [...(this.parent?.getNodePath() ?? []), this.node]
    }

    public view(): Vnode {
        return m('.TreeNode' + (this.subTree&&this.isOpen?'.open':'.close') + (this.isSelected(this.getNodePath())?'.selected':'') + (this.isVisible?'.visible':'.hidden'), {}, [
            m('.item', {}, [
                m('label.clickable', {
                    onclick: () => {
                        this.setNode(this.getNodePath());
                        this.open();
                    },
                }, this.node.label),
                this.subTree ? m('i.icon.icon-chevron-right.clickable', {
                    onclick: () => this.toggle(),
                }) : null,
            ]),
            this.subTree ? m('.subTree', {}, this.subTree.map(n => m(n))) : null,
        ]);
    }
}
